import { ConfirmationModalData } from '@shared/components/confirmation-modal/confirmation-modal.model';

export const getConfirmationData = (tenant: string): ConfirmationModalData => ({
  title: `Link Existing User to ${tenant}`,
  message: `This user already exists in our system. If you continue, the user will be linked to the ${tenant} application and will keep access to any applications already associated with their account.`,
  confirmLabel: 'Continue',
});
